<template>
  <div ref="layout" class="page-form">
    <h3 class="title">发货控制设置</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <form-button name="返回" @click="$router.go(-1)" />
        <form-button name="提交" icon="form-advance" @click="changeStatus(1)" />
        <form-button v-if="conditions.status == 0" name="保存" type="primary" @click="changeStatus(0)" />
      </div>
      <el-form inline size="mini" label-width="100px" :disabled="isEdit" :model="conditions">
        <el-row>
          <el-col :lg="8" :md="12">
            <el-form-item label="申请单号">
              <el-input
                v-model="conditions.billCode"
                placeholder="自动生成"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                v-model="conditions.createdByName"
                placeholder="请输入"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input
                v-model="conditions.createdDate"
                placeholder="请输入"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="明细信息" :custome-config="() => vxeShowCustom('xTable')">
        <template #button>
          <table-button
            v-for="btn in gridOptions.buttons"
            :key="btn.label"
            :name="btn.icon"
            :tip="btn.label"
            @click="tableEvent(btn)"
          />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="332"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #ctrlType="{row}">
            <el-select
              v-model="row.ctrlType"
              size="mini"
              :disabled="isEdit"
              @change="ctrlTypeChange($event, row)"
            >
              <el-option
                v-for="items in selectDataOptions['DeliveryRange']"
                :key="items.value"
                :label="items.name"
                :value="items.value"
              />
            </el-select>
          </template>
          <template #saleCenter="{row}">
            <el-select
              v-model="row.saleCenter"
              type="select"
              :disabled="row.ctrlType !== 'war' || isEdit"
              placeholder=""
              size="mini"
              clearable
              @change="changeGetName($event, row, 'saleList', 'saleCenterName', 'SOBID', 'MC_SHORT')"
            >
              <el-option
                v-for="item in selectDataOptions['saleList']"
                :key="item.SOBID"
                :label="item.MC_SHORT"
                :value="item.SOBID"
              />
            </el-select>
          </template>
          <template #base="{row}">
            <el-select
              v-model="row.base"
              placeholder=""
              type="select"
              :disabled="row.ctrlType !== 'area' || isEdit"
              size="mini"
              clearable
              @change="changeGetName($event, row, 'baseList', 'baseName', 'SOBID', 'MC_SHORT')"
            >
              <el-option
                v-for="item in selectDataOptions['baseList']"
                :key="item.SOBID"
                :label="item.MC_SHORT"
                :value="item.SOBID"
              />
            </el-select>
          </template>
          <template #customerCode="{row}">
            <wly-input
              ref="custInput"
              v-model="row.customerCode"
              input-type="customer"
              :disabled="row.ctrlType !== 'dealer' || isEdit"
              clearable
              @enter="handleEnter(...arguments, row)"
              @handleSuffixClick="showDialog = true"
            />
          </template>
          <template #stockType="{row}">
            <el-select
              v-model="row.stockType"
              size="mini"
              :disabled="isEdit"
              filterable
              @change="changeGetName($event, row, 'A0019', 'stockTypeName')"
            >
              <el-option
                v-for="items in selectDataOptions['A0019']"
                :key="items.value"
                :label="items.name"
                :value="items.value"
              />
            </el-select>
          </template>
          <template #planYieldGreater="{row}">
            <el-input v-model="row.planYieldGreater" :disabled="isEdit" size="mini" />
          </template>
          <template #planYieldLess="{row}">
            <el-input v-model="row.planYieldLess" :disabled="isEdit" size="mini" />
          </template>
          <template #interval="{row}">
            <el-input v-model="row.interval" :disabled="isEdit" size="mini" />
          </template>
          <template #frequency="{row}">
            <el-input v-model="row.frequency" :disabled="isEdit" size="mini" />
          </template>
          <template #remark="{row}">
            <el-input v-model="row.remark" :disabled="isEdit" size="mini" />
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="客户选择"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <client-select ref="dialogSelect" />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { filterDictionary } from '@/utils/index'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'
import {
  deliveryControlAdd,
  deleteDeliverControl,
  deliveryControlFindById
} from '@/api/applyForGoods/index'
import { mapGetters } from 'vuex'

const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
export default {
  components: {
    ClientSelect
  },
  data() {
    return {
      showDialog: false,
      conditions: {
        deliverType: '',
        province: '',
        provinceCode: '',
        saleCenter: '',
        saleCenterView: '',
        customerName: '',
        customerCode: '',
        createdDate: '',
        createdByName: '',
        createdById: '',
        city: '',
        cityCode: '',
        billCode: '',
        area: '',
        status: ''
      },
      validRules: {},
      selectDataOptions: {
        saleList: [],
        baseList: []
      },
      currentRow: {},
      errorList: [],
      gridOptions: {
        buttons: [
          {
            label: '新增',
            type: 'add',
            icon: 'add',
            style: 'primary'
          },
          {
            label: '删除',
            type: 'delete',
            icon: 'delete',
            style: 'default'
          }
        ],
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'ctrlType', title: '控制类型', slots: { default: 'ctrlType' }, width: 150 },
          { field: 'saleCenter', title: '营销中心', slots: { default: 'saleCenter' }, width: 150 },
          { field: 'base', title: '基地', slots: { default: 'base' }, width: 150 },
          { field: 'customerCode', title: '客户', slots: { default: 'customerCode' }, width: 200 },
          { field: 'customerName', title: '客户名称', width: 200, visible: false },
          { field: 'stockType', title: '存货分类', slots: { default: 'stockType' }, width: 150 },
          { field: 'planYieldGreater', title: '计划量>=', slots: { default: 'planYieldGreater' }, width: 120 },
          { field: 'planYieldLess', title: '<=计划量', slots: { default: 'planYieldLess' }, width: 120 },
          { field: 'interval', title: '间隔天数', slots: { default: 'interval' }, width: 120 },
          { field: 'frequency', title: '次/月', slots: { default: 'frequency' }, width: 120 },
          { field: 'remark', title: '备注', slots: { default: 'remark' }, width: 120 }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isEdit() {
      return false
    }
  },
  created() {
    apiGetOrgOrBase().then(res => {
      this.selectDataOptions['saleList'] = res.DATA
    })
    apiGetOrgOrBase('', 2).then(res => {
      this.selectDataOptions['baseList'] = res.DATA
    })
    if (this.$route.query.id) {
      this.initDetail(this.$route.query.id)
    } else {
      this.conditions.createdDate = this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}')
      this.conditions.createdByName = this.userInfo.name
    }
    this.getSelectDictDataOrigin('DeliveryRange')
    this.getSelectDictDataOrigin('A0019')
  },
  methods: {
    filterDictionary,
    changeGetName(e, row, dit, field, key = 'value', rkey = 'name') {
      if (e) {
        this.currentRow = row
        this.currentRow[field] = this.filterDictionary(e, dit, key, rkey)
      }
    },
    ctrlTypeChange(e, row) {
      this.currentRow = row
      if (e === 'war') {
        this.currentRow.base = ''
        this.currentRow.baseName = ''
        this.currentRow.customerCode = ''
        this.currentRow.customerName = ''
        this.$refs.xTable.hideColumn('customerName')
      } else if (e === 'dealer') {
        this.currentRow.base = ''
        this.currentRow.baseName = ''
        this.currentRow.saleCenter = ''
        this.currentRow.saleCenterName = ''
        this.$refs.xTable.showColumn('customerName')
      } else {
        this.currentRow.saleCenter = ''
        this.currentRow.saleCenterName = ''
        this.currentRow.customerCode = ''
        this.currentRow.customerName = ''
        this.$refs.xTable.hideColumn('customerName')
      }
    },
    async initDetail(id) {
      const { data } = await deliveryControlFindById({ id })
      Object.assign(this.conditions, data)
      this.gridOptions.data = data.deliverControlDetailList
    },
    changeStatus(status) {
      this.errorList = []
      if (this.gridOptions.data.length === 0) return this.$message.warning('请添加明细！')
      try {
        this.gridOptions.data.forEach((item, i) => {
          if (item.ctrlType === 'war' && !item.saleCenter) {
            throw new Error(`请选择第${i + 1}行营销单元！`)
          } else if (item.ctrlType === 'dealer' && !item.customerName) {
            throw new Error(`请选择第${i + 1}行经销商！`)
          } else if (item.ctrlType === 'area' && !item.base) {
            throw new Error(`请选择第${i + 1}行基地！`)
          }
          if (item.planYieldGreater < item.planYieldLess) {
            throw new Error('请填写正确的计划量控制区间！')
          }
        })
      } catch (e) {
        this.errorList = [e.message]
        return
      }

      const params = JSON.parse(JSON.stringify(this.conditions))
      params.status = status
      params.deliverControlDetailList = this.gridOptions.data
      deliveryControlAdd(params).then(res => {
        if (res.status === 1) {
          this.gridOptions.data = res.data.deliverControlDetailList
          Object.assign(this.conditions, res.data)
          this.$message.success('操作成功！')
        }
      })
    },
    // 控件回车
    async handleEnter(e, type, data, row) {
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!data) return
      this.currentRow = row

      this.currentRow.customerCode = data.customerCode
      this.currentRow.customerName = data.customerName
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()

      if (!data) return

      if (this.dialogTitle === '客户选择') {
        this.conditions.customerCode = data.customerCode
        this.conditions.customerName = data.customerName
        this.selectDataOptions.saleCenter = data.clientOrgList
      } else {
        this.conditions.saleCenter = data.code
        this.conditions.saleCenterName = data.name
      }
      this.showDialog = false
    },
    tableEvent(btn) {
      if (btn.type === 'add') {
        this.insertData()
      } else {
        this.removeData()
      }
    },
    insertData() {
      const data = {
        ctrlType: 'war',
        saleCenter: '',
        saleCenterName: '',
        base: '',
        baseName: '',
        customerCode: '',
        customerName: '',
        stockType: '',
        planYieldGreater: '',
        planYieldLess: '',
        remark: '',
        interval: '',
        frequency: ''
      }
      this.gridOptions.data.push(data)
    },
    async removeData() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()
      const hasIds = checkedList.filter(v => v.id)

      if (hasIds.length) {
        const ids = hasIds.map(v => v.id).join(',')
        await deleteDeliverControl({ ids })
      }
      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/deliveryControl.vue